module.exports = __webpack_public_path__ + "media/images/application/template/logos/lighthouse-ba4c1aa65b0bcea150d22032d87410ef.png";